(() => {
  'use strict';

  const drawerSelector = '#mini-cart';
  let lastCartTrigger = null;

  const setAttributeIfChanged = (element, name, value) => {
    if (element && element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  };

  const syncCartDrawer = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    const isOpen =
      drawer.classList.contains('open') ||
      document.body.classList.contains('minicart');

    setAttributeIfChanged(drawer, 'aria-hidden', isOpen ? 'false' : 'true');
    setAttributeIfChanged(
      drawer.querySelector('.mini-cart__sidebar'),
      'aria-hidden',
      isOpen ? 'false' : 'true'
    );

    const checkoutLink = drawer.querySelector('#direct-checkout');
    const visibleLineItem = drawer.querySelector('.cart-item');
    const cartCount = Math.max(
      0,
      ...Array.from(document.querySelectorAll('.cart-count')).map(
        (element) => Number.parseInt(element.textContent, 10) || 0
      )
    );
    const hasItems = Boolean(visibleLineItem) || cartCount > 0;

    if (checkoutLink && hasItems) {
      checkoutLink.removeAttribute('aria-disabled');
      checkoutLink.removeAttribute('tabindex');
      setAttributeIfChanged(checkoutLink, 'href', '/checkout');
    } else if (checkoutLink) {
      checkoutLink.removeAttribute('href');
      setAttributeIfChanged(checkoutLink, 'aria-disabled', 'true');
      setAttributeIfChanged(checkoutLink, 'tabindex', '-1');
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const cartTrigger = event.target.closest('button[name="cart-open"]');
      if (cartTrigger) lastCartTrigger = cartTrigger;

      if (event.target.closest('#cart-close') && lastCartTrigger) {
        window.setTimeout(() => {
          if (document.contains(lastCartTrigger)) lastCartTrigger.focus();
        }, 250);
      }
    },
    true
  );

  const observer = new MutationObserver(syncCartDrawer);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'href', 'aria-hidden'],
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartDrawer, { once: true });
  } else {
    syncCartDrawer();
  }
})();
